export default {
  allPassengers: [],
}
